//Libraries
import { useBreakpointValue } from '@chakra-ui/react';
// Components
import { Dialoger } from '@molecules/index';
//Types
import { DialogerTypes } from './useDialoger.type';
import { dialogerTypeMap } from './useDialoger.breakpoints';
//Data
import { useDialogerStore } from '@stores/index';

/**
 * Custom hook for managing dialog functionality.
 *
 * @returns An object containing functions and components related to dialog management.
 *
 * @example
 * ```
 * //Import the dialoger hook
 * import { useDialoger } from '@/src/hooks/useDialoger';
 *
 * ```
 * ```
 * // Destructure to get the dialoger 'onOpen' function
 * const { onOpen } = useDialoger();
 *
 * ```
 *
 * ```
 * //Use the 'onOpen' function
 * <Button
 *   onClick={() => {
 *     onOpen({
 *       title: 'Dulcinea a',
 *       subTitle: 'Last Noon Report: 10/17/2022',
 *       titleTag: '2023',
 *       placement: 'bottom',
 *       isFullHeight: true,
 *       body: {
 *         component: 'AvatarButton',
 *         props: {
 *           name: 'Avatar',
 *         },
 *       },
 *     });
 *   }}
 * >
 *   Open
 * </Button>
 *
 * ```
 */
export const useDialoger = () => {
  const { isOpen, onClose, setSetup, onOpen } = useDialogerStore();

  /**
   * A component that renders the dialog portal.
   */
  const PortaledDialoger = () => {
    const { dialogerSetup } = useDialogerStore();
    const typeDialogerStyle = useBreakpointValue(dialogerTypeMap) ?? DialogerTypes.modal;

    return (
      <Dialoger isOpen={isOpen} onClose={onClose} dialogerType={typeDialogerStyle} dialogerSetup={dialogerSetup} />
    );
  };

  return { onOpen, setSetup, PortaledDialoger };
};
